import styled, { css } from 'styled-components';
import Column from './column';

const BodyColumn = styled(Column)`
  padding: 8px;
  flex-direction: column;
  justify-content: center;
  background-color: var(--grey100);
  position: relative;
  gap: 10px;
  ${(props) =>
    !!props.onClick &&
    css`
      cursor: pointer;
      &:hover {
        background-color: var(--grey200);
      }
    `}
  ${(props) =>
    !!props.columnBorderLeftColor &&
    css`
      border-left: 3px ${props.columnBorderLeftColor} solid;
    `}
    ${(props) =>
    !!props.columnBorderLeftWidth &&
    css`
      border-left-width: ${props.columnBorderLeftWidth};
    `}
    ${(props) =>
    !!props.backgroundColor &&
    css`
      background-color: ${props.backgroundColor};
    `};
`;
export default BodyColumn;
